module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marc Olden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marc Olden (1933–2003) was the author of forty mystery and suspense novels. Born in Baltimore, he began writing while working in New York as a Broadway publicist. His first book, "), _c('I', [_vm._v("Angela Davis")]), _vm._v(" (1973), was a nonfiction study of the controversial Black Panther. In 1973 he also published "), _c('I', [_vm._v("Narc")]), _vm._v(", under the name Robert Hawke, beginning a hard-boiled nine-book series about a federal narcotics agent."), _c('P', [_vm._v("A year later, "), _c('I', [_vm._v("Black Samurai")]), _vm._v(" introduced Robert Sand, a martial arts expert who becomes the first non-Japanese student of a samurai master. Based on Olden’s own interest in martial arts, which led him to the advanced ranks of karate and aikido, the novel spawned a successful eight-book series. Olden continued writing for the next three decades, often drawing on his fascination with Japanese culture and history. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1398NOP/tc-custom/9781453260944.jpg?1703849067423",
      "alt": "This image is the cover for the book Death Song, The Narc Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Death Song, The Narc Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticClass: "MsoNormal"
  }, [_c('b', [_vm._v("After a narrow escape, Bolt goes after the mobster who tried to blow him up")])]), _c('p', {
    staticClass: "MsoNormal"
  }, [_vm._v("As far as the record industry is concerned, Matteo DiPalma is a manager, a producer, and the hit-maker behind some of the decade’s biggest chart successes. To the federal government, he is a crucial link between drug-hungry musicians and the Rosetti crime family that keeps them supplied with heroin and cocaine. When federal agents nail DiPalma on a trafficking charge, John Bolt and six other cops go to California to escort him back east. The shotguns they carry aren’t to keep DiPalma from running, but to protect him from a Rosetti hit. The agents don’t count on death from above.")]), _c('p', {
    staticClass: "MsoNormal"
  }), _c('p', {
    staticClass: "MsoNormal"
  }, [_vm._v("The mafia helicopter appears too quickly for the cops to react. Bolt is just outside the blast radius when the grenade hits the roof, vaporizing DiPalma and his guards. When the smoke clears, Bolt is bloodied but not broken—and ready to even the score. ")]), _c('p', {
    staticClass: "MsoNormal"
  }), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0